const bxfLoading48 = {
    svg: '<svg style="width:3.00rem; height:3.00rem;" viewBox="0 0 48 48"><rect width="48" height="48" rx="24" fill="black"/><circle class="circle-1" cx="14" cy="16" r="3" fill="white"/><circle class="circle-2" cx="24" cy="26" r="3" fill="white"/><circle class="circle-3" cx="34" cy="26" r="3" fill="white"/></svg>',
};

export { bxfLoading48 as default };
